import { render, staticRenderFns } from "./VolunteerReport.vue?vue&type=template&id=255ab2a7&scoped=true"
import script from "./VolunteerReport.vue?vue&type=script&lang=js"
export * from "./VolunteerReport.vue?vue&type=script&lang=js"
import style0 from "./VolunteerReport.vue?vue&type=style&index=0&id=255ab2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ab2a7",
  null
  
)

export default component.exports